export default __webpack_public_path__ + "static/media/nave_map_image.fa401372.png";